/** Matches both webpack's ChunkLoadError and Turbopack's dynamic-import failure wording. */
const STALE_CHUNK_PATTERN = /ChunkLoadError|Loading chunk [\w-]+ failed|Failed to fetch dynamically imported module/i;

export function isStaleChunkError(message: string): boolean {
  return STALE_CHUNK_PATTERN.test(message);
}
